
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://uamxqfbdhemjflnczowe.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVhbXhxZmJkaGVtamZsbmN6b3dlIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzM5NDM3NjYsImV4cCI6MTk4OTUxOTc2Nn0.UHlKI73cdDr4UZwc5k6avFdxwUroQW5xmmiCrIMXl3M'
const supabase = createClient(supabaseUrl, supabaseKey)


export default supabase;